@use "styles/abstracts/mixins/typography" as t;
@use "styles/abstracts/variables" as v;
@use "styles/abstracts/mixins/common" as m;

.introViewWrapper {
  padding: 0 16px;
  container-type: inline-size;
}

.introView {
  margin-top: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 560px;
  background-color: v.$palette-white;
  padding: 160px 24px;
  border-radius: 10px;
  box-shadow: v.$shadow-1;

  @include m.containerMedia(v.$js-defined-mobile-breakpoint) {
    height: auto;
    min-height: 240px;
    padding: 40px 16px;
  }

  svg {
    display: block;
  }

  .contentBox {
    display: flex;
    align-items: center;
    flex-direction: column;
    gap: 24px;
    max-width: 440px;
    color: v.$palette-gray-900;

    h3 {
      text-align: center;
      margin-bottom: 8px;
      font-weight: 600;
      font-size: 20px;
      line-height: 24px;
    }

    p {
      line-height: 24px;
      text-align: center;
      margin-bottom: 0;
      padding: 0px 5px;

      .separator {
        display: block;
        @include m.containerMedia(v.$tablet-breakpoint) {
          display: none;
        }
      }
    }

    .iconBox img {
      width: 60px;
      height: 60px;
    }

    .buttonSignIn {
      margin-right: 8px;
    }

    .introViewText {
      font-weight: 500;
      font-size: 16px;
    }

    .SecontText {
      margin-top: 10px;
      font-weight: 400;
      font-size: 14px;
    }
    
    .buttonSignIn,
    .buttonExploreFeatures {
      font-family: v.$primary-font;
      background: v.$palette-gray-200;
      color:  v.$palette-gray-900;
      border-radius: 8px;
    }

    .buttonBox {
      display: flex;
      flex-wrap: wrap;
      align-items: center;

      .buttonBoxItem {
        text-decoration: none;

        @include m.containerMedia(v.$tablet-breakpoint) {
          @include t.text(12px, 20px, 600);
          padding: 6px 16px;
        }
      }

      .buttonBoxItem + .buttonBoxItem {
        display: flex;
        align-items: center;
        margin-left: 24px;

        @include m.containerMedia(v.$tablet-breakpoint) {
          margin-left: 8px;
        }
      }
    }
  }

  &.seaIntro,
  &.airIntro,
  &.globalIntro {
    position: relative;
    overflow: hidden;
    height: auto;
    min-height: 110.727cqw;
    padding: 41.522cqw 9.343cqw 8.304cqw;
    background: v.$palette-pure-white;

    .contentBox {
      position: relative;
      z-index: 4;
      max-width: 81.315cqw;
      width: 100%;
      gap: 5.882cqw;
      color: v.$palette-pure-black;

      h3 {
        margin-bottom: 1.73cqw;
        font-size: 6.92cqw;
        line-height: 1;
        font-weight: 700;
        letter-spacing: -0.208cqw;
      }

      .introViewText {
        font-size: 3.114cqw;
        line-height: 1.2;
        font-weight: 400;
        color: v.$palette-text-muted;
      }

      .SecontText {
        margin-top: 0;
        font-size: 2.422cqw;
        line-height: 1.4;
        font-weight: 400;
        color: v.$palette-text-muted;
      }
    }

    .buttonBox {
      width: 100%;
      flex-wrap: nowrap;
      gap: 2.422cqw;

      .buttonBoxItem {
        flex: 1 1 0;
        display: flex;
        align-items: center;
        justify-content: center;
        height: 8.651cqw;
        padding: 0 2.076cqw;
        border-radius: 1.384cqw;
        font-size: 2.768cqw;
        line-height: 1;
        font-weight: 700;
        letter-spacing: -0.083cqw;
      }

      .buttonBoxItem + .buttonBoxItem {
        margin-left: 0;
      }
    }

    .seaSecondaryButton,
    .airSecondaryButton,
    .globalSecondaryButton {
      background: v.$palette-pure-white;
      color: v.$palette-pure-black;
    }
  }

  &.seaIntro {
    .buttonBoxItem {
      box-shadow: v.$shadow-sea-tracking;
    }

    .seaPrimaryButton {
      background: v.$palette-sea-tracking;
      color: v.$palette-pure-white;
    }
  }

  &.airIntro {
    .buttonBoxItem {
      box-shadow: v.$shadow-air-tracking;
    }

    .airPrimaryButton {
      background: v.$palette-air-tracking;
      color: v.$palette-pure-white;
    }
  }

  &.globalIntro {
    .buttonBoxItem {
      box-shadow: v.$shadow-global-tracking;
    }

    .globalPrimaryButton {
      background: v.$palette-global-tracking;
      color: v.$palette-pure-white;
    }
  }
}

.introDecorTopStage,
.introDecorBottomStage {
  position: absolute;
  left: 0;
  width: 100%;
  overflow: hidden;
  pointer-events: none;
}

.introDecorTopStage {
  top: 0;
  z-index: 2;
  aspect-ratio: 578 / 430;
}

.introDecorBottomStage {
  bottom: 0;
  z-index: 1;
  aspect-ratio: 578 / 562;
}

.introDecor {
  position: absolute;
  top: -3%;
  left: -3%;
  width: 106%;
  height: 106%;
  object-fit: cover;
  pointer-events: none;
}

.introDecorDark {
  display: none;
}

.introCubeBox {
  position: absolute;
  top: calc(102 / 430 * 100%);
  left: 50%;
  z-index: 1;
  width: calc(100 / 578 * 100%);
  aspect-ratio: 100 / 101;
  transform: translateX(-50%);
  pointer-events: none;

  img {
    display: block;
    width: 100%;
    height: 100%;
    object-fit: contain;
  }
}

:global([data-theme="dark"]) {
  .seaIntro,
  .airIntro,
  .globalIntro {
    background: v.$palette-pure-black;

    .contentBox {
      color: v.$palette-pure-white;

      .introViewText,
      .SecontText {
        color: v.$palette-text-muted-on-dark;
      }
    }

    .seaSecondaryButton,
    .airSecondaryButton,
    .globalSecondaryButton {
      background: v.$palette-pure-white;
      color: v.$palette-pure-black;
    }
  }

  .introDecorLight {
    display: none;
  }

  .introDecorDark {
    display: block;
  }
}
